import api from '@cannect/services/api'

export type TProductClass = {
  id: number
  uuid: string
  name: string
}

export type TGetClassesResponse = {
  success: boolean
  classes: TProductClass[]
}

export const getProductClasses = async () => api.get<TGetClassesResponse>('/classes').then(({ data }) => data)
